// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"CommonRequestNotificationFormFields_FormContainer__1o98V","DescriptionTextArea":"CommonRequestNotificationFormFields_DescriptionTextArea__3k3iq"};